<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,782.5l0.55,0.31l8.11,4.69v10l-8.66,5l-8.66-5v-10L0.5,782.5z M0.5,785.02l-6.48,3.75l6.48,3.74l6.48-3.74L0.5,785.02z
	"/>
</svg>

</template>